// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1sOnF","content":"Consent_content__QCt41","footer":"Consent_footer__SnEkv"};